import React, { useEffect, useState, useRef } from "react";

import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import CartWidget from "../../products/cart/CartWidget.jsx";
import LoginWidget from "../../login/LoginWidget.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import "./Navbar2.css";

import firebaseApp from "../../../firebase/Credentials.js";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

export default function NavBar2() {
  // ===================== TU LÓGICA (MISMA FUNCIÓN) =====================
  const [user, setUser] = useState(null);

  async function getRol(uid) {
    const ref = doc(firestore, `usuarios/${uid}`);
    const snap = await getDoc(ref);
    return snap.data()?.rol ?? "user";
  }

  function setUserWithFirebaseAndRol(usuarioFirebase) {
    getRol(usuarioFirebase.uid).then((rol) => {
      const userData = {
        uid: usuarioFirebase.uid,
        email: usuarioFirebase.email,
        rol: rol,
      };
      setUser(userData);
    });
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (usuarioFirebase) => {
      if (usuarioFirebase) setUserWithFirebaseAndRol(usuarioFirebase);
      else setUser(null);
    });
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ====================================================================

  // ===================== UI (SOLO VISUAL) =====================
  const [openDesktop, setOpenDesktop] = useState(null); // "bikes" | "bici" | "rider" | "account"
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState({}); // { section: true/false }

  const toggleDesktop = (key) => {
    setOpenDesktop((prev) => (prev === key ? null : key));
  };

  const closeAll = () => {
    setOpenDesktop(null);
    setDrawerOpen(false);
  };

  const toggleMobileSection = (key) => {
    setMobileOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Cerrar al click fuera + Escape (desktop)
  useEffect(() => {
    const onDocClick = (e) => {
      const inside = e.target.closest?.(".navwrap");
      if (!inside) setOpenDesktop(null);
    };
    const onEsc = (e) => {
      if (e.key === "Escape") setOpenDesktop(null);
    };
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  // Data: Bicicletas (desktop dropdown simple)
  const bikesItems = [
    { label: "Mtb", to: "/products/MTB" },
    { label: "Fixie", to: "/products/Fixie" },
    { label: "Ruta", to: "/products/Ruta" },
  ];

  // Data: Para la bici (mega)
  const paraLaBiciCols = [
    {
      title: "ESENCIALES",
      items: [
        { label: "Accesorios", to: "/products/Accesorios"},
        { label: "Candados", to: "/products/Candados"},
        { label: "Cintas y grips", to: "/products/Cintas" },
        { label: "Luces", to: "/products/Luces"},
        { label: "Neumáticos", to: "/products/Neumáticos" },
        { label: "Pedales", to: "/products/Pedales"},
      ],
    },
    {
      title: "COMPONENTES",
      items: [
        { label: "Manubrios", to: "/products/Manubrios"},
        { label: "Cañas", to: "/products/Canas"},
        { label: "Postes", to: "/products/Postes"},
        { label: "Rines y llantas", to: "/products/Rines_llantas"},
        { label: "Manzanas", to: "/products/Manzanas"},
        { label: "Sillines", to: "/products/Sillines"},
      ],
    },
    {
      title: "TRANSMISIÓN",
      items: [
        { label: "Grupos y componentes", to: "/products/Grupos_componentes"},
        { label: "Relaciones", to: "/products/Relaciones"},
        { label: "Cadenas y cadenillas", to: "/products/Cadenas_cadenillas"},
        { label: "Frenos y pastillas", to: "/products/Frenos_pastillas"},
        { label: "Pachas", to: "/products/Pachas"},
        { label: "Piñones", to: "/products/Piñones"},
        { label: "Lubricantes", to: "/products/Lubricantes"},
      ],
    },
    {
      title: "MARCOS",
      items: [
        { label: "Marcos MTB", to: "/products/MarcosMTB"},
        { label: "Marcos Fixie", to: "/products/MarcosFixie"},
        { label: "Marcos Ruta", to: "/products/MarcosRuta"},
        { label: "Tenedores y suspensiones", to: "/products/Tenedores"},
        { label: "Rodamientos", to: "/products/Rodamientos"},
        { label: "Herramientas y bombas", to: "/products/Herramientas"},
      ],
    },
  ];

  // Data: Para el rider (mega simple como el screenshot)
  const paraElRiderItems = [
    { label: "Accesorios ciclista", to: "/products/AccesoriosCiclista"},
    { label: "Cascos", to: "/products/Cascos"},
    { label: "Gafas", to: "/products/Gafas"},
    { label: "Guantes", to: "/products/Guantes"},
    { label: "Ropa", to: "/products/Ropa"},
    { label: "Zapatillas", to: "/products/Zapatillas"},
    { label: "Hidratación y suplementos", to: "/products/Hidratacion"},
  ];

  // ===================== RENDER =====================
  return (
    <header className="navwrap">
      {/* TOP BAR (FULL WIDTH) */}
      <div className="topbar">
        <div className="topbar-inner">
          <Link to="/" className="brand" onClick={() => setOpenDesktop(null)}>
            <img className="logo" src={process.env.REACT_APP_NAVBAR} alt="Logo" />
          </Link>

          {/* DESKTOP */}
          <nav className="nav-desktop">
            <Link className="navlink" to="/" onClick={() => setOpenDesktop(null)}>
              Inicio
            </Link>

            <Link className="navlink" to="/products" onClick={() => setOpenDesktop(null)}>
              Productos
            </Link>

            {/* BICICLETAS ▾ */}
            <div className={`navdrop ${openDesktop === "bikes" ? "active" : ""}`}>
              <button
                className="navbtn"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDesktop("bikes");
                }}
              >
                Bicicletas <span className="caret">▾</span>
              </button>

              {openDesktop === "bikes" && (
                <div className="dd-menu dd-compact" onClick={(e) => e.stopPropagation()}>
                  {bikesItems.map((it) => (
                    <Link
                      key={it.label}
                      to={it.to}
                      className="dd-item center"
                      onClick={() => setOpenDesktop(null)}
                    >
                      {it.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* PARA LA BICI ▾ (mega) */}
            <div className={`navdrop ${openDesktop === "bici" ? "active" : ""}`}>
              <button
                className="navbtn"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDesktop("bici");
                }}
              >
                Para la bici <span className="caret">▾</span>
              </button>
            </div>

            {/* PARA EL RIDER ▾ (mega simple) */}
            <div className={`navdrop ${openDesktop === "rider" ? "active" : ""}`}>
              <button
                className="navbtn"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDesktop("rider");
                }}
              >
                Para el rider <span className="caret">▾</span>
              </button>
            </div>

            {/* carrito */}
            <Link className="iconlink" to="/PageCart" aria-label="Carrito" onClick={() => setOpenDesktop(null)}>
              <CartWidget />
            </Link>

            {/* cuenta */}
            <div className="account">
              {!user && <LoginWidget />}

              {user && (
                <div className={`account-dd ${openDesktop === "account" ? "open" : ""}`}>
                  <button
                    className="account-btn"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleDesktop("account");
                    }}
                  >
                    Cuenta <span className="caret">▾</span>
                  </button>

                  {openDesktop === "account" && (
                    <div className="account-menu" onClick={(e) => e.stopPropagation()}>
                      <Link to="/ProfilePage" className="account-item" onClick={() => setOpenDesktop(null)}>
                        Perfil
                      </Link>

                      {user.rol === "admin" && (
                        <>
                          <Link to="/orders" className="account-item" onClick={() => setOpenDesktop(null)}>
                            Administrador
                          </Link>
                          
                        </>
                      )}

                      <div className="account-sep" />
                      <button className="account-item danger" onClick={() => signOut(auth)}>
                        Cerrar sesión
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </nav>

          {/* MOBILE ACTIONS */}
          <div className="nav-mobile-actions">
            <Link className="iconlink" to="/PageCart" aria-label="Carrito" onClick={() => setOpenDesktop(null)}>
              <CartWidget />
            </Link>

            <button className="burger" onClick={() => setDrawerOpen(true)} aria-label="Abrir menú">
              ☰
            </button>
          </div>
        </div>
      </div>

      {/* MEGA: PARA LA BICI */}
      <div className={`mega ${openDesktop === "bici" ? "show" : ""}`} onClick={(e) => e.stopPropagation()}>
        <div className="mega-inner">
          {paraLaBiciCols.map((col) => (
            <div key={col.title} className="mega-col">
              <div className="mega-title">{col.title}</div>
              <div className="mega-list">
                {col.items.map((it) => (
                  <Link key={it.label} to={it.to} className="mega-item" onClick={() => setOpenDesktop(null)}>
                    <span className="mi-ico">{it.icon}</span>
                    <span className="mi-txt">{it.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* MEGA: PARA EL RIDER */}
      <div className={`mega mega-simple ${openDesktop === "rider" ? "show" : ""}`} onClick={(e) => e.stopPropagation()}>
        <div className="mega-inner simple-grid">
          {paraElRiderItems.map((it) => (
            <Link key={it.label} to={it.to} className="mega-item" onClick={() => setOpenDesktop(null)}>
              <span className="mi-ico">{it.icon}</span>
              <span className="mi-txt">{it.label}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* OVERLAY + DRAWER MOBILE */}
      <div className={`overlay ${drawerOpen ? "show" : ""}`} onClick={closeAll} />

      <aside className={`drawer ${drawerOpen ? "open" : ""}`} aria-hidden={!drawerOpen}>
        <div className="drawer-top">
          <button className="drawer-close" onClick={closeAll} aria-label="Cerrar">
            ✕
          </button>
        </div>

        <div className="drawer-list">
          <Link className="drawer-link" to="/" onClick={closeAll}>
            Inicio
          </Link>

          {/* Bicicletas (+) */}
          <div className="drawer-section">
            <button className="drawer-head" onClick={() => toggleMobileSection("bicicletas")}>
              Bicicletas <span className="plus">{mobileOpen.bicicletas ? "–" : "+"}</span>
            </button>
            {mobileOpen.bicicletas && (
              <div className="drawer-sub">
                {bikesItems.map((it) => (
                  <Link key={it.label} to={it.to} className="drawer-sublink center" onClick={closeAll}>
                    {it.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Para la bici (+) */}
          <div className="drawer-section">
            <button className="drawer-head" onClick={() => toggleMobileSection("paraLaBici")}>
              Para la bici <span className="plus">{mobileOpen.paraLaBici ? "–" : "+"}</span>
            </button>
            {mobileOpen.paraLaBici && (
              <div className="drawer-sub">
                <button className="drawer-head subhead" onClick={() => toggleMobileSection("esenciales")}>
                  Esenciales <span className="plus">{mobileOpen.esenciales ? "–" : "+"}</span>
                </button>
                {mobileOpen.esenciales && (
                  <div className="drawer-sub">
                    <Link to="/products/Accesorios" className="drawer-sublink" onClick={closeAll}>Accesorios</Link>
                    <Link to="/products/Candados" className="drawer-sublink" onClick={closeAll}>Candados</Link>
                    <Link to="/products/Cintas" className="drawer-sublink" onClick={closeAll}>Cintas y grips</Link>
                    <Link to="/products/Neumáticos" className="drawer-sublink" onClick={closeAll}>Neumáticos</Link>
                    <Link to="/products/Pedales" className="drawer-sublink" onClick={closeAll}>Pedales</Link>
                  </div>
                )}


                <button className="drawer-head subhead" onClick={() => toggleMobileSection("componentes")}>
                  Componentes <span className="plus">{mobileOpen.componentes ? "–" : "+"}</span>
                </button>
                {mobileOpen.componentes && (
                  <div className="drawer-sub">
                    <Link to="/products/Manubrios" className="drawer-sublink" onClick={closeAll}>Manubrios</Link>
                    <Link to="/products/Canas" className="drawer-sublink" onClick={closeAll}>Cañas</Link>
                    <Link to="/products/Rines_llantas" className="drawer-sublink" onClick={closeAll}>Rines y llantas</Link>
                    <Link to="/products/Manzanas" className="drawer-sublink" onClick={closeAll}>Manzanas</Link>
                    <Link to="/products/Sillines" className="drawer-sublink" onClick={closeAll}>Sillines</Link>
                  </div>
                )}

                <button className="drawer-head subhead" onClick={() => toggleMobileSection("transmision")}>
                  Transmisión <span className="plus">{mobileOpen.transmision ? "–" : "+"}</span>
                </button>
                {mobileOpen.transmision && (
                  <div className="drawer-sub">
                    <Link to="/products/Grupos_componentes" className="drawer-sublink" onClick={closeAll}>Grupos y componentes</Link>
                    <Link to="/products/Relaciones" className="drawer-sublink" onClick={closeAll}>Relaciones</Link>
                    <Link to="/products/Cadenas_cadenillas" className="drawer-sublink" onClick={closeAll}>Cadenas y cadenillas</Link>
                    <Link to="/products/Frenos_pastillas" className="drawer-sublink" onClick={closeAll}>Frenos y pastillas</Link>
                    <Link to="/products/Pachas" className="drawer-sublink" onClick={closeAll}>Pachas</Link>
                    <Link to="/products/Piñones" className="drawer-sublink" onClick={closeAll}>Piñones</Link>
                    <Link to="/products/Lubricantes" className="drawer-sublink" onClick={closeAll}>Lubricantes</Link>
                  </div>
                )}

 
                <button className="drawer-head subhead" onClick={() => toggleMobileSection("frames")}>
                  Marcos <span className="plus">{mobileOpen.frames ? "–" : "+"}</span>
                </button>
                {mobileOpen.frames && (
                  <div className="drawer-sub">
                    <Link to="/products/MarcosMTB" className="drawer-sublink" onClick={closeAll}>Marcos MTB</Link>
                    <Link to="/products/MarcosFixie" className="drawer-sublink" onClick={closeAll}>Marcos Fixie</Link>
                    <Link to="/products/MarcosRuta" className="drawer-sublink" onClick={closeAll}>Marcos Ruta</Link>
                    <Link to="/products/Tenedores" className="drawer-sublink" onClick={closeAll}>Tenedores y suspensiones</Link>
                    <Link to="/products/Rodamientos" className="drawer-sublink" onClick={closeAll}>Rodamientos</Link>
                    <Link to="/products/Herramientas" className="drawer-sublink" onClick={closeAll}>Herramientas</Link>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Para el rider (+) */}
          <div className="drawer-section">
            <button className="drawer-head" onClick={() => toggleMobileSection("paraElRider")}>
              Para el rider <span className="plus">{mobileOpen.paraElRider ? "–" : "+"}</span>
            </button>
            {mobileOpen.paraElRider && (
              <div className="drawer-sub">
                {paraElRiderItems.map((it) => (
                  <Link key={it.label} to={it.to} className="drawer-sublink" onClick={closeAll}>
                    {it.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* Cuenta móvil */}
          <div className="drawer-account">
            {!user && <LoginWidget />}
            {user && (
              <>
                <Link to="/ProfilePage" className="drawer-link" onClick={closeAll}>
                  Perfil
                </Link>

                {user.rol === "admin" && (
                  <>
                    <Link to="/orders" className="drawer-link" onClick={closeAll}>
                      Administrador
                    </Link>
                    
                  </>
                )}

                <button
                  className="drawer-link drawer-btn danger"
                  onClick={() => {
                    signOut(auth);
                    closeAll();
                  }}
                >
                  Cerrar sesión
                </button>
              </>
            )}
          </div>
        </div>
      </aside>
    </header>
  );
}